import React from "react";
import "../styles/features.css";
import secure from "../images/secure.gif";
import rotate from "../images/views.gif";
import fast from "../images/money.gif";

const Features = () => {
  return (
    <section
      id="features"
      className="features-section"
      itemScope
      itemType="https://schema.org/WebPageElement"
    >
      <div className="features-container">
        <div className="features-header">
          <span className="features-subtitle">
            Why Choose Classic Motors KE
          </span>
          <h2 className="features-title" itemProp="headline">
            Premium Car Buying Experience in Mombasa
          </h2>
        </div>

        <div className="features-grid">
          <div
            className="feature-card feature-card-1"
            itemScope
            itemType="https://schema.org/Offer"
          >
            <div className="feature-icon">
              <img
                src={secure}
                alt="Secure Car Payment Options in Kenya"
                className="feature-gif"
                itemProp="image"
                loading="lazy"
              />
            </div>
            <h3 className="feature-title" itemProp="name">
              Trusted Payment Security
            </h3>
            <p className="feature-description" itemProp="description">
              At Classic Motors KE, we prioritize your security with bank-level
              encryption for all transactions. As Mombasa's leading car dealer,
              we offer multiple secure payment options for both new and used
              vehicles.
            </p>
          </div>

          <div
            className="feature-card feature-card-2"
            itemScope
            itemType="https://schema.org/Offer"
          >
            <div className="feature-icon">
              <img
                src={rotate}
                alt="360° Car Visualization - View Vehicles Online"
                className="feature-gif"
                itemProp="image"
                loading="lazy"
              />
            </div>
            <h3 className="feature-title" itemProp="name">
              Detailed 360° Views
            </h3>
            <p className="feature-description" itemProp="description">
              Experience every angle of your potential vehicle with our
              immersive 360° visualization. Perfect for customers importing cars
              to Kenya or browsing our Mombasa showroom inventory remotely.
            </p>
          </div>

          <div
            className="feature-card feature-card-3"
            itemScope
            itemType="https://schema.org/Offer"
          >
            <div className="feature-icon">
              <img
                src={fast}
                alt="Fast Car Import Process Kenya"
                className="feature-gif"
                itemProp="image"
                loading="lazy"
              />
            </div>
            <h3 className="feature-title" itemProp="name">
              Efficient Import Process
            </h3>
            <p className="feature-description" itemProp="description">
              Our streamlined import service boasts a 100% delivery record. We
              handle all paperwork and logistics for foreign and used cars,
              making vehicle importation to Kenya hassle-free.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
